var config = {
	// api请求地址
	baseUrl: 'https://zhuoqiu.xing-peng.com/index.php/api',
	// 图片域名
	imgDomain: '',
	//上传文件地址
	uploadUrl: '',
};

export default config;


// WEBPACK FOOTER //
// ./src/api/config.js